import { useDebounce } from 'use-debounce';

const DEFAULT_DEBOUNCE_DELAY = 300;
export function useDebouncedValue<T>(
  value: T,
  delay: number = DEFAULT_DEBOUNCE_DELAY,
) {
  return useDebounce(value, delay);
}
